import API from '@/API/API'

const AdminServiceFieldsStore = {
  api: API,
  state: {
    currentUserId: 0,
    form:{
      searchable:'0',
      required:'0',
      type:'Text',
      title:'',
      characterLimit:0,
      selectOptions:'',
      showInTable:'0',
      showInTableOnSmall:'0'
    },
    service:{},
    fields:[],
    serviceId: 0,
    types:[
      "Text",
      "Number",
      "Y/N",
      "State",
      "Select Dropdown",
      "Multi Select Dropdown",
      "Date",
      "Email",
      "Website",
    ]
  },
  createServiceField: function(success,error,maintenance){
    let self = this;
    this.state.form.serviceId = this.state.serviceId



    this.api
    .createAdminServiceField(this.state.form)
    .then(function (res) {
      
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            success(data);
        }
      }else{
          error("Failed to create service");
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  },
  getService: function(success,error,maintenance) {
    let self = this;
    this.api
    .retrieveAdminService(this.state.serviceId)
    .then(function (res) {
      
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
          self.state.service = data.service
          self.state.fields = data.fields
          success(data);
        }
      }else{
          error("Failed to get service");
      }
    })
    .catch(e => {
      
      error('An Error Occurred')
    })
  },
  resetForm: function(){
    this.state.form = {
      searchable:'0',
      required:'0',
      type:'Text',
      title:'',
      characterLimit:0,
      selectOptions:'',
      showInTable:'0',
      showInTableOnSmall:'0'
    };
  },

  disableServiceField:function(success,error,maintenance) {
    let self = this;
    this.api
    .adminDisableServiceField(this.state.disableFieldId)
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
          success(data);
        }
      }else{
          error("Failed to disable service field");
      }
    })
    .catch(e => {
      
      error('An Error Occurred')
    })
  }
}

export default AdminServiceFieldsStore



// WEBPACK FOOTER //
// ./src/components/admin/AdminServiceFieldsStore.js